// removed by extract-text-webpack-plugin
module.exports = {"TargetingDisplay":"TargetingDisplay---1EyjJ"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/playbook/components/TargetingDisplay/style.styl
// module id = Yt9r
// module chunks = 89